let pendingCheckoutForm = null
let pendingCheckoutButton = null
let allowCheckout = false

function getUpsellOverlay() {
  return document.getElementById('custom-upsell-overlay')
}

function getSelectionMessage() {
  return document.getElementById('upsell-selection-message')
}

function showSelectionMessage() {
  const message = getSelectionMessage()
  if (!message) return
  message.style.display = 'block'
}

function hideSelectionMessage() {
  const message = getSelectionMessage()
  if (!message) return
  message.style.display = 'none'
}

function openUpsellModal() {
  const overlay = getUpsellOverlay()
  if (!overlay) return
  overlay.style.display = 'flex'
  overlay.classList.add('active')
  document.body.classList.add('upsell-open')
  hideSelectionMessage()
}

function closeUpsellModal() {
  const overlay = getUpsellOverlay()
  if (!overlay) return
  overlay.style.display = 'none'
  overlay.classList.remove('active')
  document.body.classList.remove('upsell-open')
  hideSelectionMessage()
}

function proceedToCheckout() {
  allowCheckout = true
  closeUpsellModal()

  if (pendingCheckoutButton) {
    const formId = pendingCheckoutButton.getAttribute('form')
    if (formId) {
      const form = document.getElementById(formId)
      if (form) {
        form.submit()
        return
      }
    }
  }

  if (pendingCheckoutForm) {
    pendingCheckoutForm.submit()
    return
  }

  window.location.href = '/checkout'
}

function updateCardPrice(card) {
  if (!card) return

  const select = card.querySelector('.upsell-variant-select')
  const priceEl = card.querySelector('[data-price]')
  const comparePriceEl = card.querySelector('[data-compare-price]')

  if (!select || !priceEl) return

  let selectedOption = null

  if (select.tagName.toLowerCase() === 'select') {
    selectedOption = select.options[select.selectedIndex]
  } else {
    selectedOption = select
  }

  if (!selectedOption) return

  const price = selectedOption.getAttribute('data-price') || ''
  const comparePrice = selectedOption.getAttribute('data-compare-price') || ''

  priceEl.textContent = price

  if (comparePriceEl) {
    if (comparePrice && comparePrice !== price) {
      comparePriceEl.textContent = comparePrice
      comparePriceEl.style.display = ''
    } else {
      comparePriceEl.textContent = ''
      comparePriceEl.style.display = 'none'
    }
  }
}

function getSelectedUpsellItems() {
  const cards = document.querySelectorAll('.upsell-product-card')
  const items = []

  cards.forEach(function (card) {
    const toggle = card.querySelector('.upsell-product-toggle')
    const select = card.querySelector('.upsell-variant-select')

    if (!toggle || !toggle.checked || !select) return

    const variantId = select.value
    if (!variantId) return

    items.push({
      id: Number(variantId),
      quantity: 1
    })
  })

  return items
}

async function addUpsellToCartAndCheckout() {
  const button = document.getElementById('trigger-upsell-add')
  const items = getSelectedUpsellItems()

  if (!items.length) {
    showSelectionMessage()
    return
  }

  hideSelectionMessage()

  try {
    if (button) {
      button.disabled = true
      button.textContent = 'מוסיף את הפריטים...'
    }

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: items
      })
    })

    if (!response.ok) {
      throw new Error('Failed to add upsell items')
    }

    proceedToCheckout()
  } catch (error) {
    console.error('Upsell add failed:', error)
    proceedToCheckout()
  } finally {
    if (button) {
      button.disabled = false
      button.textContent = 'הוסף את המסומנים והמשך לתשלום'
    }
  }
}

document.addEventListener('change', function (event) {
  const select = event.target.closest('.upsell-variant-select')
  if (select) {
    const card = select.closest('.upsell-product-card')
    updateCardPrice(card)
  }

  const toggle = event.target.closest('.upsell-product-toggle')
  if (toggle && toggle.checked) {
    hideSelectionMessage()
  }
})

document.addEventListener('click', function (event) {
  const closeBtn = event.target.closest('.close-upsell-btn')
  if (closeBtn) {
    event.preventDefault()
    closeUpsellModal()
    return
  }

  const skipBtn = event.target.closest('.btn-skip-upsell')
  if (skipBtn) {
    event.preventDefault()
    proceedToCheckout()
    return
  }

  const upsellBtn = event.target.closest('#trigger-upsell-add')
  if (upsellBtn) {
    event.preventDefault()
    addUpsellToCartAndCheckout()
    return
  }

  const checkoutBtn = event.target.closest('button[name="checkout"]')
  if (!checkoutBtn) return

  if (allowCheckout) return

  const overlay = getUpsellOverlay()
  if (!overlay) {
    return
  }

  event.preventDefault()
  event.stopPropagation()

  pendingCheckoutButton = checkoutBtn

  const formId = checkoutBtn.getAttribute('form')
  if (formId) {
    pendingCheckoutForm = document.getElementById(formId)
  } else {
    pendingCheckoutForm = checkoutBtn.closest('form')
  }

  const cards = document.querySelectorAll('.upsell-product-card')
  cards.forEach(function (card) {
    updateCardPrice(card)
  })

  openUpsellModal()
})